module.exports = __webpack_public_path__ + "ma.svg?c91b74041cf00efd50fc30b8e4d91ffb";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/ma.svg
// module id = 1483
// module chunks = 0